<template>
  <div class="transaction-history">
    <table>
      <thead>
        <tr>
          <th>{{ $t(`ID`) }}</th>
          <th>{{ $t(`DATE`) }}</th>
          <th>{{ $t(`TYPE`) }}</th>
          <th>{{ $t(`TOTAL`) }}</th>
          <th>{{ $t(`STATUS`) }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="transaction in transactions" :key="transaction.id">
          <td>{{ transaction.id }}</td>
          <td>{{ formatDate(transaction.created_at) }}</td>
          <td>{{ $t(getType(transaction.type)) }}</td>
          <td>
            {{ formatCurrency(transaction.sum, transaction?.currency?.symbol) }}
          </td>
          <td>
            <span
              class="status-badge"
              :class="transaction.status.toLowerCase()"
            >
              {{ getStatus(transaction.status) }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "TransactionHistory",
  data() {
    return {
      transactions: [],
    };
  },
  methods: {
    formatDate(timestamp) {
      return moment.unix(timestamp).format("DD.MM.YYYY HH:mm");
    },
    formatCurrency(amount, currency) {
      return `${currency}${parseFloat(amount).toFixed(2)}`;
    },
    getStatus(status) {
      switch (status.toLowerCase()) {
        case "pending":
          return this.$t("Pending");
        case "success":
          return this.$t("Success");
        case "error":
          return this.$t("Error");
        case "failed":
          return this.$t("Failed");
        default:
          return this.$t("Unknown");
      }
    },
    getType(type) {
      switch (type.toLowerCase()) {
        case "deposit":
          return this.$t(`Top up balance`);
        case "payout":
          return this.$t("Withdrawal");
        default:
          return this.$t("Unknown");
      }
    },
    fetchTransactionHistory() {
      this.$http
        .get(`/transactions`)
        .then((res) => {
          this.transactions = res.data.payload;
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.$emit("open-sign-in");
          }
        });
    },
  },
  created() {
    this.fetchTransactionHistory();
  },
};
</script>

<style scoped>
.transaction-history {
  overflow-x: auto;
  margin-top: 32px;
}

table {
  width: 100%;
  border-collapse: collapse;
  display: grid;
  /* Enable grid layout */
  grid-template-columns: 0.5fr 1.5fr 4fr 2fr 1fr;
  /* Define column widths using fr units */
}

thead,
tbody,
tr {
  display: contents;
  /* Make table rows and cells grid items */
}

th,
td {
  padding: 16px;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  text-align: left;
  display: flex;
  align-items: center;
}

th {
  color: #fff;
  padding: 20px;
  background: #2b2b2b;
}
th:first-child {
  border-radius: 12px 0 0 12px;
}

th:last-child {
  border-radius: 0 12px 12px 0;
}
td {
  font-weight: 400;
  color: #fff;
  padding: 13px 20px 13px;
}

/* Special padding for the first row */
tbody tr:first-of-type td {
  padding-top: 20px;
}

.status-badge {
  width: 100%;
  display: inline-block;
  padding: 7px 12px;
  border-radius: 2px;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  /* Center text within badge */
  text-transform: uppercase;
}

.status-badge.success {
  color: #27d639;
}

.status-badge.pending {
  color: #ffbf00;
}

.status-badge.error {
  color: #ff0000;
}

/* Responsiveness - Example using media queries */
@media (max-width: 768px) {
}
</style>
